import classNames from 'classnames'
import React, { CSSProperties, FC } from 'react'

import styles from './Skeleton.module.scss'

export interface SkeletonProps {
  as?: 'div' | 'span'
  width?: string | number
  height?: string | number
  variant?: 'text' | 'circle' | 'rect' | 'rounded'
  className?: string
  inverse?: boolean
}

export const Skeleton: FC<SkeletonProps> = ({
  as: Component = 'div',
  width,
  inverse,
  height,
  variant = 'text',
  className,
}) => {
  const style: CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  }

  return (
    <Component
      className={classNames(styles.skeleton, className, {
        [styles.circle]: variant === 'circle',
        [styles.rect]: variant === 'rect',
        [styles.rounded]: variant === 'rounded',
        [styles.inverse]: inverse,
      })}
      style={style}
      aria-hidden
    />
  )
}

export interface SkeletonRowProps {
  columns: number
  className?: string
}

export const SkeletonRow: FC<SkeletonRowProps> = ({ columns, className }) => {
  return (
    <tr className={classNames(styles.skeletonRow, className)}>
      {Array.from({ length: columns }).map((_, index) => (
        <td key={index} className={styles.skeletonCell}>
          <Skeleton width={`${60 + Math.random() * 30}%`} />
        </td>
      ))}
    </tr>
  )
}

export interface SkeletonRowsProps {
  rows: number
  columns: number
  className?: string
}

export const SkeletonRows: FC<SkeletonRowsProps> = ({ rows, columns, className }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <SkeletonRow key={index} columns={columns} className={className} />
      ))}
    </>
  )
}
